.container {
  border: 1px solid var(--color-gray-200);
  border-radius: 32px;
  padding: 24px;
}